// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"df538cc9","110":"c23a9622","137":"832cb91f","152":"a1025d76","251":"212e76df","613":"5bc824f6","725":"a888f185","763":"ecfd4aad","963":"ae9daf96","982":"6f3d900a"}[chunkId] + ".chunk.js";
};